<template>
  <section class="relative z-10">
    <SectionScrollingCards
      :copy="title"
      :cards="cards"
      :gradient-top="backgroundGradientTop"
      :gradient-bottom="backgroundGradientBottom" />
  </section>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useAsyncData } from '#app'
  import { queryContent } from '#imports'

  import type { LeaderType } from '~/models/leaders'

  const { title, backgroundGradientTop, backgroundGradientBottom } = defineProps<Props>()

  const { data: leadersData } = await useAsyncData(
    'leaders',
    async () => (await queryContent('leaders').find()) as unknown as LeaderType[]
  )

  type Props = {
    title: string
    backgroundGradientTop: string
    backgroundGradientBottom: string
  }

  const leaders = computed((): LeaderType[] => leadersData.value ?? [])

  // Sort by optional `order` property
  const leadersSorted = computed(() => [...leaders.value].sort((a, b) => (a.order || 0) - (b.order || 0)))

  // Transform leaders to cards expected by SectionScrollingCards/CardGradientVertical
  const cards = computed(() =>
    leadersSorted.value.map(leader => ({
      title: `${leader.name}`,
      copy: formatLeaderCopy(leader),
      backgroundImage: leader.portrait || undefined
    }))
  )

  function formatLeaderCopy(leader: LeaderType): string {
    const parts: string[] = []

    if (leader.position) {
      parts.push(`<p class="font-normal">${leader.position}</p>`)
    }
    return parts.join('')
  }
</script>
